import { Select, styled } from "@mui/material";

export const FilterSelectField = (styled(Select)`
  background-color: ${(props) => props.theme.palette.common.white};
` as unknown) as typeof Select;
